import Vue from 'vue'
import VueRouter from 'vue-router'
import vertical from '@/navigation/vertical/index'
import { canNavigate } from '@/plugins/acl/routeProtection'
import { permission } from '@core/utils/permission'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/adhibition/:appKey?',
    name: 'adhibition',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '应用中心',
        titleEn: "Application center",
        permCode: "new_00",
        icon: "appstore",
        layout: 'content',
    },
    component: resolve => require(['@/pages/adhibition/index.vue'], resolve),
  },
  // {
  //   path: '/adhibition/blank',
  //   name: 'adhibitionBlank',
  //   noShow: true,
  //   meta: {
  //       requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
  //       title: '',
  //   },
  //   component: resolve => require(['@/pages/adhibition/blank.vue'], resolve),
  // },
  {
    path: '/personal-data/:appKey?',
    name: 'personalData',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '个人资料',
        titleEn: "Personal data",
        permCode: "new_01",
        icon: "user",
        layout: 'content',
    },
    component: resolve => require(['@/pages/personalData/index.vue'], resolve),
  },
  // {
  //   path: '/authorization/:appKey?',
  //   name: 'authorization',
  //   meta: {
  //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
  //     title: '应用权限委托',
  //     titleEn: "Personal data",
  //     permCode: "new_06",
  //     icon: "user",
  //     layout: 'content',
  //   },
  //   component: resolve => require(['@/pages/authorization/index.vue'], resolve),
  // },
  {
    path: '/account/:appKey?',
    name: 'account',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '账号安全',
        titleEn: "Account security",
        permCode: "new_02",
        icon: "lock",
        layout: 'content',
    },
    component: resolve => require(['@/pages/account/index.vue'], resolve),
  },
  {
    path: '/preference/:appKey?',
    name: 'preference',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '个人偏好',
        titleEn: "Personal preference",
        permCode: "new_03",
        icon: "idcard",
        layout: 'content',
    },
    component: resolve => require(['@/pages/preference/index.vue'], resolve),
  },
  {
    path: '/log/:appKey?',
    name: 'log',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '操作记录',
        titleEn: "Operating record",
        permCode: "new_04",
        icon: "tool",
        layout: 'content',
    },
    component: resolve => require(['@/pages/log/index.vue'], resolve),
  },
  {
    path: '/inform/:appKey?',
    name: 'inform',
    meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: '消息通知',
        titleEn: "Message notification",
        permCode: "",
        icon: "bell",
        layout: 'content',
    },
    component: resolve => require(['@/pages/inform/index'], resolve),
  },
  // {
  //   path: '/todo/:appKey?',
  //   name: 'todo',
  //   meta: {
  //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
  //     title: '我的待办',
  //     titleEn: "My To Do",
  //     permCode: "",
  //     icon: "assignment",
  //     layout: 'content',
  //   },
  //   component: resolve => require(['@/pages/toDo/index'], resolve),
  // },
  {
    path: '/zeroTrust/:appKey?',
    name: 'zeroTrust',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      title: '零信任办公',
      titleEn: "Zero Trust Office",
      permCode: "",
      icon: "mdiAccountKeyOutline",
      layout: 'content',
    },
    component: resolve => require(['@/pages/zeroTrust/index'], resolve),
  },
  {
    path: '/login/:appKey?',
    name: 'login',
    component: resolve => require(['@/pages/login/index.vue'], resolve),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
      path: '/yxl-bind',
      name: 'yxl',
      meta: {
          layout: 'blank',
      },
      component: resolve => require(['@/pages/login/yxl-bind.vue'], resolve),
  },
  {
      path: '/yxl-bind-sucess',
      name: 'yxlBindSucess',
      meta: {
          layout: 'blank',
      },
      component: resolve => require(['@/pages/login/yxl-bind-sucess.vue'], resolve),
  },
  {
    path: '/downSapPage',
    name: 'downSapPage',
    meta: {
        layout: 'blank',
    },
    component: resolve => require(['@/pages/adhibition/downSAP.vue'], resolve),
},
  {
      path: '/ws-fed',
      name: 'ws-fed',
      meta: {
          layout: 'blank',
      },
      component: resolve => require(['@/pages/login/ws-fed'], resolve),
  },
  {
    path: '/subAccount',
    name: 'subAccount',
    meta: {
        layout: 'blank',
    },
    component: resolve => require(['@/pages/login/subAccount.vue'], resolve),
  },
  {
    path: '/loginAd',
    name: 'loginAd',
    meta: {
        layout: 'blank',
    },
    component: resolve => require(['@/pages/login/loginAd.vue'], resolve),
  },
  {
      path:'/error',
      name:'error',
      component:  resolve => require(['@/pages/result/error.vue'], resolve),
      meta: {
          title: 'error',
          layout: 'blank',
      },
  },
  {
      path:'/404',
      name:404,
      component: resolve => require(['@/pages/result/404.vue'], resolve),
      meta: {
          title: '404未找到',
          layout: 'blank',
      },
  },
  {
    path:'/501',
    name:501,
    component: resolve => require(['@/pages/result/501.vue'], resolve),
    meta: {
      title: '501',
      layout: 'blank',
    },
  },
  {
      path:"*",
      redirect:"/404"
  }
]


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    }
    return {x: 0, y: 0 };
  },
})

// const router = new VueRouter({
//   mode: 'history',
//   // base: process.env.BASE_URL,
//   routes,
//   scrollBehavior() {
//     return { x: 0, y: 0 }
//   },
// })


// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
// router.beforeEach((to, _, next) => {
// console.log("🚀 ~ file: index.js ~ line 169 ~ router.beforeEach ~ to", to)

//   const isLoggedIn = getCookie("userInfo")

//   // const isLoggedIn = userInfo

//   if (!canNavigate(to)) {
//     console.log("===========", !isLoggedIn)
//     if (!isLoggedIn) return next({ name: 'login', query: { marketplace: to.query.marketplace } })

//     return next({ name: 'misc-not-authorized' })
//   }

//   // Redirect if logged in
//   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//     next('/')
//   }
//   return next()
// })

// export default router
